module.exports = __webpack_public_path__ + "static/media/redirect.e68fce25.svg";